export default __webpack_public_path__ + "static/char-s-42-zh-Hans-04c2fe2c3e682eeaee839bbaa859e13f.webp";